module.exports = __webpack_public_path__ + "img/wechat-title.9931d3b5.png";